import {Injectable} from '@angular/core';
import {API_CONFIG} from './api.config';

@Injectable({providedIn: 'root'})
export class ApiConfigService {
  constructor() {
  }

  get baseUrl(): string {
    return API_CONFIG.apiBaseUrl;
  }

  getApartmentUrl(apartmentId: number): string {
    return this.baseUrl + `${API_CONFIG.getApartmentPath(apartmentId)}`;
  }

  getCheckinsUrl(): string {
    return this.baseUrl + `${API_CONFIG.getCheckInsPath}`;
  }

  getContractTypeUrl(): string {
    return this.baseUrl + `${API_CONFIG.getContractTypePath}`;
  }

  getCheckinsWithChildrenUrl(): string {
    return this.baseUrl + `${API_CONFIG.getCheckinsWithChildrenPath}`;
  }

  setCheckinUrl(): string {
    return this.baseUrl + `${API_CONFIG.setCheckinPath}`;
  }

  setCheckinMinorUrl(): string {
    return this.baseUrl + `${API_CONFIG.setCheckinMinorPath}`;
  }

  getDoorsUrl(apartmentId: number): string {
    return this.baseUrl + `${API_CONFIG.getDoorsPath(apartmentId)}`
  }

  postOpenDoorUrl(): string {
    return this.baseUrl + `${API_CONFIG.postOpenDoorPath}`;
  }

  getHouseRulesUrl(apartmentId: number): string {
    return this.baseUrl + `${API_CONFIG.getHouseRulesPath(apartmentId)}`;
  }

  getHowWorksUrl(apartmentId: number): string {
    return this.baseUrl + `${API_CONFIG.getHowWorksPath(apartmentId)}`;
  }

  getInfoUrl(apartmentId: number): string {
    return this.baseUrl + `${API_CONFIG.getInfoPath(apartmentId)}`;
  }

  getMarkersUrl(apartmentId: number): string {
    return this.baseUrl + `${API_CONFIG.getMarkersPath(apartmentId)}`;
  }

  getPaymentStatusUrl(): string {
    return this.baseUrl + `${API_CONFIG.getPaymentStatusPath}`;
  }

  getPaymentCheckinsUrl(): string {
    return this.baseUrl + `${API_CONFIG.getPaymentCheckinsPath}`;
  }

  getPaymentFormUrl(): string {
    return this.baseUrl + `${API_CONFIG.getPaymentFormPath}`;
  }

  getRecommendationsUrl(apartmentId: number): string {
    return this.baseUrl + `${API_CONFIG.getRecommendationsPath(apartmentId)}`;
  }

  getReservationUrl(): string {
    return this.baseUrl + `${API_CONFIG.getReservationPath}`;
  }

  setSignatureUrl(): string {
    return this.baseUrl + `${API_CONFIG.setSignature}`;
  }

  getCountriesUrl() {
    return this.baseUrl + `${API_CONFIG.getCountriesPath}`;
  }

  getProvincesUrl() {
      return this.baseUrl + `${API_CONFIG.getProvincesPath}`;
  }

  getBrandingUrl(environment: string): string {
    return this.baseUrl + `${API_CONFIG.getBrandingPath(environment)}`;
  }

  getMunicipalitiesUrl(province: number) {
    return this.baseUrl + `${API_CONFIG.getMunicipalitiesPath(province)}`;
  }

  saveFamilyRelationshipsUrl() {
    return this.baseUrl + `${API_CONFIG.saveFamilyRelationshipsPath}`;
  }

  getFamilyRelationshipsUrl() {
    return this.baseUrl + `${API_CONFIG.getFamilyRelationshipsPath}`;
  }

  getCheckInStatusUrl() {
    return this.baseUrl + `${API_CONFIG.getCheckInStatusPath}`;
  }

  getLoginPath() {
    return this.baseUrl + `${API_CONFIG.getTokenPath}`;
  }
}
